"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.ChainName = void 0;
var ChainName;
(function (ChainName) {
    ChainName["EthereumMainnet"] = "Ethereum Mainnet";
    ChainName["ExpanseNetwork"] = "Expanse Network";
    ChainName["EthereumTestnetRopsten"] = "Ethereum Testnet Ropsten";
    ChainName["EthereumTestnetRinkeby"] = "Ethereum Testnet Rinkeby";
    ChainName["EthereumTestnetG\u00F6rli"] = "Ethereum Testnet G\u00F6rli";
    ChainName["EthereumClassicTestnetKotti"] = "Ethereum Classic Testnet Kotti";
    ChainName["ThaiChain"] = "ThaiChain";
    ChainName["Ubiq"] = "Ubiq";
    ChainName["UbiqNetworkTestnet"] = "Ubiq Network Testnet";
    ChainName["OptimisticEthereum"] = "Optimistic Ethereum";
    ChainName["MetadiumMainnet"] = "Metadium Mainnet";
    ChainName["MetadiumTestnet"] = "Metadium Testnet";
    ChainName["DiodeTestnetStaging"] = "Diode Testnet Staging";
    ChainName["FlareMainnet"] = "Flare Mainnet";
    ChainName["DiodePrenet"] = "Diode Prenet";
    ChainName["FlareTestnetCoston"] = "Flare Testnet Coston";
    ChainName["ThaiChain2.0ThaiFi"] = "ThaiChain 2.0 ThaiFi";
    ChainName["ThunderCoreTestnet"] = "ThunderCore Testnet";
    ChainName["SongbirdCanary-Network"] = "Songbird Canary-Network";
    ChainName["ELA-ETH-SidechainMainnet"] = "ELA-ETH-Sidechain Mainnet";
    ChainName["ELA-ETH-SidechainTestnet"] = "ELA-ETH-Sidechain Testnet";
    ChainName["ELA-DID-SidechainMainnet"] = "ELA-DID-Sidechain Mainnet";
    ChainName["ELA-DID-SidechainTestnet"] = "ELA-DID-Sidechain Testnet";
    ChainName["CronosMainnetBeta"] = "Cronos Mainnet Beta";
    ChainName["GenesisL1testnet"] = "Genesis L1 testnet";
    ChainName["ShibaChain"] = "ShibaChain";
    ChainName["BobaNetworkRinkebyTestnet"] = "Boba Network Rinkeby Testnet";
    ChainName["GenesisL1"] = "Genesis L1";
    ChainName["RSKMainnet"] = "RSK Mainnet";
    ChainName["RSKTestnet"] = "RSK Testnet";
    ChainName["GoodDataTestnet"] = "GoodData Testnet";
    ChainName["GoodDataMainnet"] = "GoodData Mainnet";
    ChainName["TBWGChain"] = "TBWG Chain";
    ChainName["Valorbit"] = "Valorbit";
    ChainName["TelosEVMMainnet"] = "Telos EVM Mainnet";
    ChainName["TelosEVMTestnet"] = "Telos EVM Testnet";
    ChainName["EthereumTestnetKovan"] = "Ethereum Testnet Kovan";
    ChainName["DarwiniaPangolinTestnet"] = "Darwinia Pangolin Testnet";
    ChainName["DarwiniaCrabNetwork"] = "Darwinia Crab Network";
    ChainName["XinFinNetworkMainnet"] = "XinFin Network Mainnet";
    ChainName["XinFinApothemTestnet"] = "XinFin Apothem Testnet";
    ChainName["CoinExSmartChainMainnet"] = "CoinEx Smart Chain Mainnet";
    ChainName["CoinExSmartChainTestnet"] = "CoinEx Smart Chain Testnet";
    ChainName["ZyxMainnet"] = "Zyx Mainnet";
    ChainName["BinanceSmartChainMainnet"] = "Binance Smart Chain Mainnet";
    ChainName["OntologyMainnet"] = "Ontology Mainnet";
    ChainName["EOSMainnet"] = "EOS Mainnet";
    ChainName["GoChain"] = "GoChain";
    ChainName["EthereumClassicMainnet"] = "Ethereum Classic Mainnet";
    ChainName["EthereumClassicTestnetMorden"] = "Ethereum Classic Testnet Morden";
    ChainName["EthereumClassicTestnetMordor"] = "Ethereum Classic Testnet Mordor";
    ChainName["Ellaism"] = "Ellaism";
    ChainName["OKExChainTestnet"] = "OKExChain Testnet";
    ChainName["OKExChainMainnet"] = "OKExChain Mainnet";
    ChainName["DBChainTestnet"] = "DBChain Testnet";
    ChainName["SoterOneMainnet"] = "SoterOne Mainnet";
    ChainName["OptimisticEthereumTestnetKovan"] = "Optimistic Ethereum Testnet Kovan";
    ChainName["Mix"] = "Mix";
    ChainName["POANetworkSokol"] = "POA Network Sokol";
    ChainName["PrimusChainmainnet"] = "PrimusChain mainnet";
    ChainName["GeneChain"] = "GeneChain";
    ChainName["MeterMainnet"] = "Meter Mainnet";
    ChainName["MeterTestnet"] = "Meter Testnet";
    ChainName["GateChainTestnet"] = "GateChain Testnet";
    ChainName["GateChainMainnet"] = "GateChain Mainnet";
    ChainName["TomoChain"] = "TomoChain";
    ChainName["CryptoKylinTestnet"] = "CryptoKylin Testnet";
    ChainName["NEXTSmartChain"] = "NEXT Smart Chain";
    ChainName["BinanceSmartChainTestnet"] = "Binance Smart Chain Testnet";
    ChainName["POANetworkCore"] = "POA Network Core";
    ChainName["XDAIChain"] = "xDAI Chain";
    ChainName["EtherInc"] = "EtherInc";
    ChainName["Web3GamesTestnet"] = "Web3Games Testnet";
    ChainName["VelasEVMMainnet"] = "Velas EVM Mainnet";
    ChainName["ThunderCoreMainnet"] = "ThunderCore Mainnet";
    ChainName["ProtonTestnet"] = "Proton Testnet";
    ChainName["EtherLiteChain"] = "EtherLite Chain";
    ChainName["FuseMainnet"] = "Fuse Mainnet";
    ChainName["FuseSparknet"] = "Fuse Sparknet";
    ChainName["DecentralizedWebMainnet"] = "Decentralized Web Mainnet";
    ChainName["Factory127Mainnet"] = "Factory 127 Mainnet";
    ChainName["HuobiECOChainMainnet"] = "Huobi ECO Chain Mainnet";
    ChainName["PolygonMainnet"] = "Polygon Mainnet";
    ChainName["DAXCHAIN"] = "DAX CHAIN";
    ChainName["LightstreamsTestnet"] = "Lightstreams Testnet";
    ChainName["LightstreamsMainnet"] = "Lightstreams Mainnet";
    ChainName["HOOSmartChainTestnet"] = "HOO Smart Chain Testnet";
    ChainName["Latam-BlockchainResilTestnet"] = "Latam-Blockchain Resil Testnet";
    ChainName["SeeleMainnet"] = "Seele Mainnet";
    ChainName["BitTorrentChainMainnet"] = "BitTorrent Chain Mainnet";
    ChainName["ArbitrumonxDai"] = "Arbitrum on xDai";
    ChainName["FreightTrustNetwork"] = "Freight Trust Network";
    ChainName["Permission"] = "Permission";
    ChainName["EnergyWebChain"] = "Energy Web Chain";
    ChainName["FantomOpera"] = "Fantom Opera";
    ChainName["HuobiECOChainTestnet"] = "Huobi ECO Chain Testnet";
    ChainName["SURBlockchainNetwork"] = "SUR Blockchain Network";
    ChainName["HighPerformanceBlockchain"] = "High Performance Blockchain";
    ChainName["BobaNetwork"] = "Boba Network";
    ChainName["KCCMainnet"] = "KCC Mainnet";
    ChainName["KCCTestnet"] = "KCC Testnet";
    ChainName["Shiden"] = "Shiden";
    ChainName["CronosTestnet"] = "Cronos Testnet";
    ChainName["ThetaMainnet"] = "Theta Mainnet";
    ChainName["ThetaSapphireTestnet"] = "Theta Sapphire Testnet";
    ChainName["ThetaAmberTestnet"] = "Theta Amber Testnet";
    ChainName["ThetaTestnet"] = "Theta Testnet";
    ChainName["PulseChainMainnet"] = "PulseChain Mainnet";
    ChainName["Lisinski"] = "Lisinski";
    ChainName["OptimisticEthereumTestnetGoerli"] = "Optimistic Ethereum Testnet Goerli";
    ChainName["Rupaya"] = "Rupaya";
    ChainName["TaoNetwork"] = "Tao Network";
    ChainName["MetisStardustTestnet"] = "Metis Stardust Testnet";
    ChainName["AcalaMandalaTestnet"] = "Acala Mandala Testnet";
    ChainName["PixieChainTestnet"] = "Pixie Chain Testnet";
    ChainName["KaruraNetwork"] = "Karura Network";
    ChainName["Factory127Testnet"] = "Factory 127 Testnet";
    ChainName["CheapETH"] = "cheapETH";
    ChainName["AcalaNetwork"] = "Acala Network";
    ChainName["Haic"] = "Haic";
    ChainName["CallistoMainnet"] = "Callisto Mainnet";
    ChainName["CallistoTestnet"] = "Callisto Testnet";
    ChainName["AmbrosChainMainnet"] = "Ambros Chain Mainnet";
    ChainName["Wanchain"] = "Wanchain";
    ChainName["PulseChainTestnet"] = "PulseChain Testnet";
    ChainName["NepalBlockchainNetwork"] = "Nepal Blockchain Network";
    ChainName["LuckyNetwork"] = "Lucky Network";
    ChainName["WanchainTestnet"] = "Wanchain Testnet";
    ChainName["KlaytnTestnetBaobab"] = "Klaytn Testnet Baobab";
    ChainName["NewtonTestnet"] = "Newton Testnet";
    ChainName["EvriceNetwork"] = "Evrice Network";
    ChainName["Newton"] = "Newton";
    ChainName["Sakura"] = "Sakura";
    ChainName["CloverTestnet"] = "Clover Testnet";
    ChainName["CloverMainnet"] = "Clover Mainnet";
    ChainName["BitTorrentChainTestnet"] = "BitTorrent Chain Testnet";
    ChainName["MetisAndromedaMainnet"] = "Metis Andromeda Mainnet";
    ChainName["MathChain"] = "MathChain";
    ChainName["MathChainTestnet"] = "MathChain Testnet";
    ChainName["WorldTradeTechnicalChainMainnet"] = "World Trade Technical Chain Mainnet";
    ChainName["PopcateumMainnet"] = "Popcateum Mainnet";
    ChainName["HALOMainnet"] = "HALO Mainnet";
    ChainName["Moonbeam"] = "Moonbeam";
    ChainName["Moonriver"] = "Moonriver";
    ChainName["Moonrock"] = "Moonrock";
    ChainName["MoonbaseAlpha"] = "Moonbase Alpha";
    ChainName["Moonshadow"] = "Moonshadow";
    ChainName["CatecoinChainMainnet"] = "Catecoin Chain Mainnet";
    ChainName["Atheios"] = "Atheios";
    ChainName["Btachain"] = "Btachain";
    ChainName["Teslafunds"] = "Teslafunds";
    ChainName["EtherGem"] = "EtherGem";
    ChainName["420coin"] = "420coin";
    ChainName["EdgewareMainnet"] = "Edgeware Mainnet";
    ChainName["BeresheetTestnet"] = "Beresheet Testnet";
    ChainName["EcoballMainnet"] = "Ecoball Mainnet";
    ChainName["EcoballTestnetEspuma"] = "Ecoball Testnet Espuma";
    ChainName["KorthoMainnet"] = "Kortho Mainnet";
    ChainName["ZCoreTestnet"] = "ZCore Testnet";
    ChainName["FantomTestnet"] = "Fantom Testnet";
    ChainName["IoTeXNetworkMainnet"] = "IoTeX Network Mainnet";
    ChainName["IoTeXNetworkTestnet"] = "IoTeX Network Testnet";
    ChainName["EraSwapMainnet"] = "EraSwap Mainnet";
    ChainName["UzmiNetworkMainnet"] = "Uzmi Network Mainnet";
    ChainName["SyscoinTanenbaumTestnet"] = "Syscoin Tanenbaum Testnet";
    ChainName["OntologyTestnet"] = "Ontology Testnet";
    ChainName["WegochainRubidiumMainnet"] = "Wegochain Rubidium Mainnet";
    ChainName["PixieChainMainnet"] = "Pixie Chain Mainnet";
    ChainName["HazlorTestnet"] = "Hazlor Testnet";
    ChainName["MDGLTestnet"] = "MDGL Testnet";
    ChainName["GeneChainAdenineTestnet"] = "GeneChain Adenine Testnet";
    ChainName["KlaytnMainnetCypress"] = "Klaytn Mainnet Cypress";
    ChainName["KorthoTest"] = "KorthoTest";
    ChainName["TOOLGlobalMainnet"] = "TOOL Global Mainnet";
    ChainName["TOOLGlobalTestnet"] = "TOOL Global Testnet";
    ChainName["AmbrosChainTestnet"] = "Ambros Chain Testnet";
    ChainName["Bloxberg"] = "bloxberg";
    ChainName["EvmosTestnet"] = "Evmos Testnet";
    ChainName["MyOwnTestnet"] = "myOwn Testnet";
    ChainName["SmartBitcoinCash"] = "Smart Bitcoin Cash";
    ChainName["SmartBitcoinCashTestnet"] = "Smart Bitcoin Cash Testnet";
    ChainName["BlockchainGenesisMainnet"] = "Blockchain Genesis Mainnet";
    ChainName["SingularityZEROTestnet"] = "Singularity ZERO Testnet";
    ChainName["SingularityZEROMainnet"] = "Singularity ZERO Mainnet";
    ChainName["MetaDotMainnet"] = "MetaDot Mainnet";
    ChainName["MetaDotTestnet"] = "MetaDot Testnet";
    ChainName["Webchain"] = "Webchain";
    ChainName["MintMe.comCoin"] = "MintMe.com Coin";
    ChainName["EthersocialNetwork"] = "Ethersocial Network";
    ChainName["GoChainTestnet"] = "GoChain Testnet";
    ChainName["FusionMainnet"] = "Fusion Mainnet";
    ChainName["EnergiMainnet"] = "Energi Mainnet";
    ChainName["Pegglecoin"] = "pegglecoin";
    ChainName["ArbitrumOne"] = "Arbitrum One";
    ChainName["CeloMainnet"] = "Celo Mainnet";
    ChainName["Athereum"] = "Athereum";
    ChainName["AvalancheFujiTestnet"] = "Avalanche Fuji Testnet";
    ChainName["AvalancheMainnet"] = "Avalanche Mainnet";
    ChainName["CeloAlfajoresTestnet"] = "Celo Alfajores Testnet";
    ChainName["EnergiTestnet"] = "Energi Testnet";
    ChainName["ThinkiumTestnetChain0"] = "Thinkium Testnet Chain 0";
    ChainName["ThinkiumTestnetChain1"] = "Thinkium Testnet Chain 1";
    ChainName["ThinkiumTestnetChain2"] = "Thinkium Testnet Chain 2";
    ChainName["ThinkiumTestnetChain103"] = "Thinkium Testnet Chain 103";
    ChainName["CeloBaklavaTestnet"] = "Celo Baklava Testnet";
    ChainName["ThinkiumMainnetChain0"] = "Thinkium Mainnet Chain 0";
    ChainName["ThinkiumMainnetChain1"] = "Thinkium Mainnet Chain 1";
    ChainName["ThinkiumMainnetChain2"] = "Thinkium Mainnet Chain 2";
    ChainName["ThinkiumMainnetChain103"] = "Thinkium Mainnet Chain 103";
    ChainName["PolyjuiceTestnet"] = "Polyjuice Testnet";
    ChainName["EnergyWebVoltaTestnet"] = "Energy Web Volta Testnet";
    ChainName["Firenzetestnetwork"] = "Firenze test network";
    ChainName["PolygonTestnetMumbai"] = "Polygon Testnet Mumbai";
    ChainName["QuarkChainMainnetRoot"] = "QuarkChain Mainnet Root";
    ChainName["QuarkChainMainnetShard0"] = "QuarkChain Mainnet Shard 0";
    ChainName["QuarkChainMainnetShard1"] = "QuarkChain Mainnet Shard 1";
    ChainName["QuarkChainMainnetShard2"] = "QuarkChain Mainnet Shard 2";
    ChainName["QuarkChainMainnetShard3"] = "QuarkChain Mainnet Shard 3";
    ChainName["QuarkChainMainnetShard4"] = "QuarkChain Mainnet Shard 4";
    ChainName["QuarkChainMainnetShard5"] = "QuarkChain Mainnet Shard 5";
    ChainName["QuarkChainMainnetShard6"] = "QuarkChain Mainnet Shard 6";
    ChainName["QuarkChainMainnetShard7"] = "QuarkChain Mainnet Shard 7";
    ChainName["QuarkChainDevnetRoot"] = "QuarkChain Devnet Root";
    ChainName["QuarkChainDevnetShard0"] = "QuarkChain Devnet Shard 0";
    ChainName["QuarkChainDevnetShard1"] = "QuarkChain Devnet Shard 1";
    ChainName["QuarkChainDevnetShard2"] = "QuarkChain Devnet Shard 2";
    ChainName["QuarkChainDevnetShard3"] = "QuarkChain Devnet Shard 3";
    ChainName["QuarkChainDevnetShard4"] = "QuarkChain Devnet Shard 4";
    ChainName["QuarkChainDevnetShard5"] = "QuarkChain Devnet Shard 5";
    ChainName["QuarkChainDevnetShard6"] = "QuarkChain Devnet Shard 6";
    ChainName["QuarkChainDevnetShard7"] = "QuarkChain Devnet Shard 7";
    ChainName["Akroma"] = "Akroma";
    ChainName["AlayaDevTestnet"] = "Alaya Dev Testnet";
    ChainName["PlatONDevTestnet"] = "PlatON Dev Testnet";
    ChainName["ARTISsigma1"] = "ARTIS sigma1";
    ChainName["ARTISTestnettau1"] = "ARTIS Testnet tau1";
    ChainName["SocialSmartChainMainnet"] = "Social Smart Chain Mainnet";
    ChainName["PolisTestnet"] = "Polis Testnet";
    ChainName["PolisMainnet"] = "Polis Mainnet";
    ChainName["ArbitrumTestnetRinkeby"] = "Arbitrum Testnet Rinkeby";
    ChainName["EluvioContentFabric"] = "Eluvio Content Fabric";
    ChainName["EthoProtocol"] = "Etho Protocol";
    ChainName["Xerom"] = "Xerom";
    ChainName["Musicoin"] = "Musicoin";
    ChainName["PepChainChurchill"] = "PepChain Churchill";
    ChainName["IOLite"] = "IOLite";
    ChainName["Quarkblockchain"] = "quarkblockchain";
    ChainName["AuxiliumNetworkMainnet"] = "Auxilium Network Mainnet";
    ChainName["JoysDigitalMainnet"] = "Joys Digital Mainnet";
    ChainName["Aquachain"] = "Aquachain";
    ChainName["JoysDigitalTestNet"] = "Joys Digital TestNet";
    ChainName["GatherMainnetNetwork"] = "Gather Mainnet Network";
    ChainName["NeonEVMDevNet"] = "Neon EVM DevNet";
    ChainName["NeonEVMMainNet"] = "Neon EVM MainNet";
    ChainName["NeonEVMTestNet"] = "Neon EVM TestNet";
    ChainName["OneLedgerMainnet"] = "OneLedger Mainnet";
    ChainName["GatherTesnetNetwork"] = "Gather Tesnet Network";
    ChainName["GatherDevnetNetwork"] = "Gather Devnet Network";
    ChainName["IPOSNetwork"] = "IPOS Network";
    ChainName["AuroraMainNet"] = "Aurora MainNet";
    ChainName["AuroraTestNet"] = "Aurora TestNet";
    ChainName["AuroraBetaNet"] = "Aurora BetaNet";
    ChainName["HarmonyMainnetShard0"] = "Harmony Mainnet Shard 0";
    ChainName["HarmonyMainnetShard1"] = "Harmony Mainnet Shard 1";
    ChainName["HarmonyMainnetShard2"] = "Harmony Mainnet Shard 2";
    ChainName["HarmonyMainnetShard3"] = "Harmony Mainnet Shard 3";
    ChainName["HarmonyTestnetShard0"] = "Harmony Testnet Shard 0";
    ChainName["HarmonyTestnetShard1"] = "Harmony Testnet Shard 1";
    ChainName["HarmonyTestnetShard2"] = "Harmony Testnet Shard 2";
    ChainName["HarmonyTestnetShard3"] = "Harmony Testnet Shard 3";
    ChainName["Pirl"] = "Pirl";
    ChainName["OneLedgerTestnetFrankenstein"] = "OneLedger Testnet Frankenstein";
    ChainName["PalmTestnet"] = "Palm Testnet";
    ChainName["PalmMainnet"] = "Palm Mainnet";
    ChainName["NtityMainnet"] = "Ntity Mainnet";
    ChainName["HaradevTestnet"] = "Haradev Testnet";
    ChainName["MolereumNetwork"] = "Molereum Network";
})(ChainName = exports.ChainName || (exports.ChainName = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["EthereumMainnet"] = 1] = "EthereumMainnet";
    ChainId[ChainId["ExpanseNetwork"] = 2] = "ExpanseNetwork";
    ChainId[ChainId["EthereumTestnetRopsten"] = 3] = "EthereumTestnetRopsten";
    ChainId[ChainId["EthereumTestnetRinkeby"] = 4] = "EthereumTestnetRinkeby";
    ChainId[ChainId["EthereumTestnetG\u00F6rli"] = 5] = "EthereumTestnetG\u00F6rli";
    ChainId[ChainId["EthereumClassicTestnetKotti"] = 6] = "EthereumClassicTestnetKotti";
    ChainId[ChainId["ThaiChain"] = 7] = "ThaiChain";
    ChainId[ChainId["Ubiq"] = 8] = "Ubiq";
    ChainId[ChainId["UbiqNetworkTestnet"] = 9] = "UbiqNetworkTestnet";
    ChainId[ChainId["OptimisticEthereum"] = 10] = "OptimisticEthereum";
    ChainId[ChainId["MetadiumMainnet"] = 11] = "MetadiumMainnet";
    ChainId[ChainId["MetadiumTestnet"] = 12] = "MetadiumTestnet";
    ChainId[ChainId["DiodeTestnetStaging"] = 13] = "DiodeTestnetStaging";
    ChainId[ChainId["FlareMainnet"] = 14] = "FlareMainnet";
    ChainId[ChainId["DiodePrenet"] = 15] = "DiodePrenet";
    ChainId[ChainId["FlareTestnetCoston"] = 16] = "FlareTestnetCoston";
    ChainId[ChainId["ThaiChain2.0ThaiFi"] = 17] = "ThaiChain2.0ThaiFi";
    ChainId[ChainId["ThunderCoreTestnet"] = 18] = "ThunderCoreTestnet";
    ChainId[ChainId["SongbirdCanary-Network"] = 19] = "SongbirdCanary-Network";
    ChainId[ChainId["ELA-ETH-SidechainMainnet"] = 20] = "ELA-ETH-SidechainMainnet";
    ChainId[ChainId["ELA-ETH-SidechainTestnet"] = 21] = "ELA-ETH-SidechainTestnet";
    ChainId[ChainId["ELA-DID-SidechainMainnet"] = 22] = "ELA-DID-SidechainMainnet";
    ChainId[ChainId["ELA-DID-SidechainTestnet"] = 23] = "ELA-DID-SidechainTestnet";
    ChainId[ChainId["CronosMainnetBeta"] = 25] = "CronosMainnetBeta";
    ChainId[ChainId["GenesisL1testnet"] = 26] = "GenesisL1testnet";
    ChainId[ChainId["ShibaChain"] = 27] = "ShibaChain";
    ChainId[ChainId["BobaNetworkRinkebyTestnet"] = 28] = "BobaNetworkRinkebyTestnet";
    ChainId[ChainId["GenesisL1"] = 29] = "GenesisL1";
    ChainId[ChainId["RSKMainnet"] = 30] = "RSKMainnet";
    ChainId[ChainId["RSKTestnet"] = 31] = "RSKTestnet";
    ChainId[ChainId["GoodDataTestnet"] = 32] = "GoodDataTestnet";
    ChainId[ChainId["GoodDataMainnet"] = 33] = "GoodDataMainnet";
    ChainId[ChainId["TBWGChain"] = 35] = "TBWGChain";
    ChainId[ChainId["Valorbit"] = 38] = "Valorbit";
    ChainId[ChainId["TelosEVMMainnet"] = 40] = "TelosEVMMainnet";
    ChainId[ChainId["TelosEVMTestnet"] = 41] = "TelosEVMTestnet";
    ChainId[ChainId["EthereumTestnetKovan"] = 42] = "EthereumTestnetKovan";
    ChainId[ChainId["DarwiniaPangolinTestnet"] = 43] = "DarwiniaPangolinTestnet";
    ChainId[ChainId["DarwiniaCrabNetwork"] = 44] = "DarwiniaCrabNetwork";
    ChainId[ChainId["XinFinNetworkMainnet"] = 50] = "XinFinNetworkMainnet";
    ChainId[ChainId["XinFinApothemTestnet"] = 51] = "XinFinApothemTestnet";
    ChainId[ChainId["CoinExSmartChainMainnet"] = 52] = "CoinExSmartChainMainnet";
    ChainId[ChainId["CoinExSmartChainTestnet"] = 53] = "CoinExSmartChainTestnet";
    ChainId[ChainId["ZyxMainnet"] = 55] = "ZyxMainnet";
    ChainId[ChainId["BinanceSmartChainMainnet"] = 56] = "BinanceSmartChainMainnet";
    ChainId[ChainId["OntologyMainnet"] = 58] = "OntologyMainnet";
    ChainId[ChainId["EOSMainnet"] = 59] = "EOSMainnet";
    ChainId[ChainId["GoChain"] = 60] = "GoChain";
    ChainId[ChainId["EthereumClassicMainnet"] = 61] = "EthereumClassicMainnet";
    ChainId[ChainId["EthereumClassicTestnetMorden"] = 62] = "EthereumClassicTestnetMorden";
    ChainId[ChainId["EthereumClassicTestnetMordor"] = 63] = "EthereumClassicTestnetMordor";
    ChainId[ChainId["Ellaism"] = 64] = "Ellaism";
    ChainId[ChainId["OKExChainTestnet"] = 65] = "OKExChainTestnet";
    ChainId[ChainId["OKExChainMainnet"] = 66] = "OKExChainMainnet";
    ChainId[ChainId["DBChainTestnet"] = 67] = "DBChainTestnet";
    ChainId[ChainId["SoterOneMainnet"] = 68] = "SoterOneMainnet";
    ChainId[ChainId["OptimisticEthereumTestnetKovan"] = 69] = "OptimisticEthereumTestnetKovan";
    ChainId[ChainId["Mix"] = 76] = "Mix";
    ChainId[ChainId["POANetworkSokol"] = 77] = "POANetworkSokol";
    ChainId[ChainId["PrimusChainmainnet"] = 78] = "PrimusChainmainnet";
    ChainId[ChainId["GeneChain"] = 80] = "GeneChain";
    ChainId[ChainId["MeterMainnet"] = 82] = "MeterMainnet";
    ChainId[ChainId["MeterTestnet"] = 83] = "MeterTestnet";
    ChainId[ChainId["GateChainTestnet"] = 85] = "GateChainTestnet";
    ChainId[ChainId["GateChainMainnet"] = 86] = "GateChainMainnet";
    ChainId[ChainId["TomoChain"] = 88] = "TomoChain";
    ChainId[ChainId["CryptoKylinTestnet"] = 95] = "CryptoKylinTestnet";
    ChainId[ChainId["NEXTSmartChain"] = 96] = "NEXTSmartChain";
    ChainId[ChainId["BinanceSmartChainTestnet"] = 97] = "BinanceSmartChainTestnet";
    ChainId[ChainId["POANetworkCore"] = 99] = "POANetworkCore";
    ChainId[ChainId["XDAIChain"] = 100] = "XDAIChain";
    ChainId[ChainId["EtherInc"] = 101] = "EtherInc";
    ChainId[ChainId["Web3GamesTestnet"] = 102] = "Web3GamesTestnet";
    ChainId[ChainId["VelasEVMMainnet"] = 106] = "VelasEVMMainnet";
    ChainId[ChainId["ThunderCoreMainnet"] = 108] = "ThunderCoreMainnet";
    ChainId[ChainId["ProtonTestnet"] = 110] = "ProtonTestnet";
    ChainId[ChainId["EtherLiteChain"] = 111] = "EtherLiteChain";
    ChainId[ChainId["FuseMainnet"] = 122] = "FuseMainnet";
    ChainId[ChainId["FuseSparknet"] = 123] = "FuseSparknet";
    ChainId[ChainId["DecentralizedWebMainnet"] = 124] = "DecentralizedWebMainnet";
    ChainId[ChainId["Factory127Mainnet"] = 127] = "Factory127Mainnet";
    ChainId[ChainId["HuobiECOChainMainnet"] = 128] = "HuobiECOChainMainnet";
    ChainId[ChainId["PolygonMainnet"] = 137] = "PolygonMainnet";
    ChainId[ChainId["DAXCHAIN"] = 142] = "DAXCHAIN";
    ChainId[ChainId["LightstreamsTestnet"] = 162] = "LightstreamsTestnet";
    ChainId[ChainId["LightstreamsMainnet"] = 163] = "LightstreamsMainnet";
    ChainId[ChainId["HOOSmartChainTestnet"] = 170] = "HOOSmartChainTestnet";
    ChainId[ChainId["Latam-BlockchainResilTestnet"] = 172] = "Latam-BlockchainResilTestnet";
    ChainId[ChainId["SeeleMainnet"] = 186] = "SeeleMainnet";
    ChainId[ChainId["BitTorrentChainMainnet"] = 199] = "BitTorrentChainMainnet";
    ChainId[ChainId["ArbitrumonxDai"] = 200] = "ArbitrumonxDai";
    ChainId[ChainId["FreightTrustNetwork"] = 211] = "FreightTrustNetwork";
    ChainId[ChainId["Permission"] = 222] = "Permission";
    ChainId[ChainId["EnergyWebChain"] = 246] = "EnergyWebChain";
    ChainId[ChainId["FantomOpera"] = 250] = "FantomOpera";
    ChainId[ChainId["HuobiECOChainTestnet"] = 256] = "HuobiECOChainTestnet";
    ChainId[ChainId["SURBlockchainNetwork"] = 262] = "SURBlockchainNetwork";
    ChainId[ChainId["HighPerformanceBlockchain"] = 269] = "HighPerformanceBlockchain";
    ChainId[ChainId["BobaNetwork"] = 288] = "BobaNetwork";
    ChainId[ChainId["KCCMainnet"] = 321] = "KCCMainnet";
    ChainId[ChainId["KCCTestnet"] = 322] = "KCCTestnet";
    ChainId[ChainId["Shiden"] = 336] = "Shiden";
    ChainId[ChainId["CronosTestnet"] = 338] = "CronosTestnet";
    ChainId[ChainId["ThetaMainnet"] = 361] = "ThetaMainnet";
    ChainId[ChainId["ThetaSapphireTestnet"] = 363] = "ThetaSapphireTestnet";
    ChainId[ChainId["ThetaAmberTestnet"] = 364] = "ThetaAmberTestnet";
    ChainId[ChainId["ThetaTestnet"] = 365] = "ThetaTestnet";
    ChainId[ChainId["PulseChainMainnet"] = 369] = "PulseChainMainnet";
    ChainId[ChainId["Lisinski"] = 385] = "Lisinski";
    ChainId[ChainId["OptimisticEthereumTestnetGoerli"] = 420] = "OptimisticEthereumTestnetGoerli";
    ChainId[ChainId["Rupaya"] = 499] = "Rupaya";
    ChainId[ChainId["TaoNetwork"] = 558] = "TaoNetwork";
    ChainId[ChainId["MetisStardustTestnet"] = 588] = "MetisStardustTestnet";
    ChainId[ChainId["AcalaMandalaTestnet"] = 595] = "AcalaMandalaTestnet";
    ChainId[ChainId["PixieChainTestnet"] = 666] = "PixieChainTestnet";
    ChainId[ChainId["KaruraNetwork"] = 686] = "KaruraNetwork";
    ChainId[ChainId["Factory127Testnet"] = 721] = "Factory127Testnet";
    ChainId[ChainId["CheapETH"] = 777] = "CheapETH";
    ChainId[ChainId["AcalaNetwork"] = 787] = "AcalaNetwork";
    ChainId[ChainId["Haic"] = 803] = "Haic";
    ChainId[ChainId["CallistoMainnet"] = 820] = "CallistoMainnet";
    ChainId[ChainId["CallistoTestnet"] = 821] = "CallistoTestnet";
    ChainId[ChainId["AmbrosChainMainnet"] = 880] = "AmbrosChainMainnet";
    ChainId[ChainId["Wanchain"] = 888] = "Wanchain";
    ChainId[ChainId["PulseChainTestnet"] = 940] = "PulseChainTestnet";
    ChainId[ChainId["NepalBlockchainNetwork"] = 977] = "NepalBlockchainNetwork";
    ChainId[ChainId["LuckyNetwork"] = 998] = "LuckyNetwork";
    ChainId[ChainId["WanchainTestnet"] = 999] = "WanchainTestnet";
    ChainId[ChainId["KlaytnTestnetBaobab"] = 1001] = "KlaytnTestnetBaobab";
    ChainId[ChainId["NewtonTestnet"] = 1007] = "NewtonTestnet";
    ChainId[ChainId["EvriceNetwork"] = 1010] = "EvriceNetwork";
    ChainId[ChainId["Newton"] = 1012] = "Newton";
    ChainId[ChainId["Sakura"] = 1022] = "Sakura";
    ChainId[ChainId["CloverTestnet"] = 1023] = "CloverTestnet";
    ChainId[ChainId["CloverMainnet"] = 1024] = "CloverMainnet";
    ChainId[ChainId["BitTorrentChainTestnet"] = 1028] = "BitTorrentChainTestnet";
    ChainId[ChainId["MetisAndromedaMainnet"] = 1088] = "MetisAndromedaMainnet";
    ChainId[ChainId["MathChain"] = 1139] = "MathChain";
    ChainId[ChainId["MathChainTestnet"] = 1140] = "MathChainTestnet";
    ChainId[ChainId["WorldTradeTechnicalChainMainnet"] = 1202] = "WorldTradeTechnicalChainMainnet";
    ChainId[ChainId["PopcateumMainnet"] = 1213] = "PopcateumMainnet";
    ChainId[ChainId["HALOMainnet"] = 1280] = "HALOMainnet";
    ChainId[ChainId["Moonbeam"] = 1284] = "Moonbeam";
    ChainId[ChainId["Moonriver"] = 1285] = "Moonriver";
    ChainId[ChainId["Moonrock"] = 1286] = "Moonrock";
    ChainId[ChainId["MoonbaseAlpha"] = 1287] = "MoonbaseAlpha";
    ChainId[ChainId["Moonshadow"] = 1288] = "Moonshadow";
    ChainId[ChainId["CatecoinChainMainnet"] = 1618] = "CatecoinChainMainnet";
    ChainId[ChainId["Atheios"] = 1620] = "Atheios";
    ChainId[ChainId["Btachain"] = 1657] = "Btachain";
    ChainId[ChainId["Teslafunds"] = 1856] = "Teslafunds";
    ChainId[ChainId["EtherGem"] = 1987] = "EtherGem";
    ChainId[ChainId["420coin"] = 2020] = "420coin";
    ChainId[ChainId["EdgewareMainnet"] = 2021] = "EdgewareMainnet";
    ChainId[ChainId["BeresheetTestnet"] = 2022] = "BeresheetTestnet";
    ChainId[ChainId["EcoballMainnet"] = 2100] = "EcoballMainnet";
    ChainId[ChainId["EcoballTestnetEspuma"] = 2101] = "EcoballTestnetEspuma";
    ChainId[ChainId["KorthoMainnet"] = 2559] = "KorthoMainnet";
    ChainId[ChainId["ZCoreTestnet"] = 3331] = "ZCoreTestnet";
    ChainId[ChainId["FantomTestnet"] = 4002] = "FantomTestnet";
    ChainId[ChainId["IoTeXNetworkMainnet"] = 4689] = "IoTeXNetworkMainnet";
    ChainId[ChainId["IoTeXNetworkTestnet"] = 4690] = "IoTeXNetworkTestnet";
    ChainId[ChainId["EraSwapMainnet"] = 5197] = "EraSwapMainnet";
    ChainId[ChainId["UzmiNetworkMainnet"] = 5315] = "UzmiNetworkMainnet";
    ChainId[ChainId["SyscoinTanenbaumTestnet"] = 5700] = "SyscoinTanenbaumTestnet";
    ChainId[ChainId["OntologyTestnet"] = 5851] = "OntologyTestnet";
    ChainId[ChainId["WegochainRubidiumMainnet"] = 5869] = "WegochainRubidiumMainnet";
    ChainId[ChainId["PixieChainMainnet"] = 6626] = "PixieChainMainnet";
    ChainId[ChainId["HazlorTestnet"] = 7878] = "HazlorTestnet";
    ChainId[ChainId["MDGLTestnet"] = 8029] = "MDGLTestnet";
    ChainId[ChainId["GeneChainAdenineTestnet"] = 8080] = "GeneChainAdenineTestnet";
    ChainId[ChainId["KlaytnMainnetCypress"] = 8217] = "KlaytnMainnetCypress";
    ChainId[ChainId["KorthoTest"] = 8285] = "KorthoTest";
    ChainId[ChainId["TOOLGlobalMainnet"] = 8723] = "TOOLGlobalMainnet";
    ChainId[ChainId["TOOLGlobalTestnet"] = 8724] = "TOOLGlobalTestnet";
    ChainId[ChainId["AmbrosChainTestnet"] = 8888] = "AmbrosChainTestnet";
    ChainId[ChainId["Bloxberg"] = 8995] = "Bloxberg";
    ChainId[ChainId["EvmosTestnet"] = 9000] = "EvmosTestnet";
    ChainId[ChainId["MyOwnTestnet"] = 9999] = "MyOwnTestnet";
    ChainId[ChainId["SmartBitcoinCash"] = 10000] = "SmartBitcoinCash";
    ChainId[ChainId["SmartBitcoinCashTestnet"] = 10001] = "SmartBitcoinCashTestnet";
    ChainId[ChainId["BlockchainGenesisMainnet"] = 10101] = "BlockchainGenesisMainnet";
    ChainId[ChainId["SingularityZEROTestnet"] = 12051] = "SingularityZEROTestnet";
    ChainId[ChainId["SingularityZEROMainnet"] = 12052] = "SingularityZEROMainnet";
    ChainId[ChainId["MetaDotMainnet"] = 16000] = "MetaDotMainnet";
    ChainId[ChainId["MetaDotTestnet"] = 16001] = "MetaDotTestnet";
    ChainId[ChainId["Webchain"] = 24484] = "Webchain";
    ChainId[ChainId["MintMe.comCoin"] = 24734] = "MintMe.comCoin";
    ChainId[ChainId["EthersocialNetwork"] = 31102] = "EthersocialNetwork";
    ChainId[ChainId["GoChainTestnet"] = 31337] = "GoChainTestnet";
    ChainId[ChainId["FusionMainnet"] = 32659] = "FusionMainnet";
    ChainId[ChainId["EnergiMainnet"] = 39797] = "EnergiMainnet";
    ChainId[ChainId["Pegglecoin"] = 42069] = "Pegglecoin";
    ChainId[ChainId["ArbitrumOne"] = 42161] = "ArbitrumOne";
    ChainId[ChainId["CeloMainnet"] = 42220] = "CeloMainnet";
    ChainId[ChainId["Athereum"] = 43110] = "Athereum";
    ChainId[ChainId["AvalancheFujiTestnet"] = 43113] = "AvalancheFujiTestnet";
    ChainId[ChainId["AvalancheMainnet"] = 43114] = "AvalancheMainnet";
    ChainId[ChainId["CeloAlfajoresTestnet"] = 44787] = "CeloAlfajoresTestnet";
    ChainId[ChainId["EnergiTestnet"] = 49797] = "EnergiTestnet";
    ChainId[ChainId["ThinkiumTestnetChain0"] = 60000] = "ThinkiumTestnetChain0";
    ChainId[ChainId["ThinkiumTestnetChain1"] = 60001] = "ThinkiumTestnetChain1";
    ChainId[ChainId["ThinkiumTestnetChain2"] = 60002] = "ThinkiumTestnetChain2";
    ChainId[ChainId["ThinkiumTestnetChain103"] = 60103] = "ThinkiumTestnetChain103";
    ChainId[ChainId["CeloBaklavaTestnet"] = 62320] = "CeloBaklavaTestnet";
    ChainId[ChainId["ThinkiumMainnetChain0"] = 70000] = "ThinkiumMainnetChain0";
    ChainId[ChainId["ThinkiumMainnetChain1"] = 70001] = "ThinkiumMainnetChain1";
    ChainId[ChainId["ThinkiumMainnetChain2"] = 70002] = "ThinkiumMainnetChain2";
    ChainId[ChainId["ThinkiumMainnetChain103"] = 70103] = "ThinkiumMainnetChain103";
    ChainId[ChainId["PolyjuiceTestnet"] = 71393] = "PolyjuiceTestnet";
    ChainId[ChainId["EnergyWebVoltaTestnet"] = 73799] = "EnergyWebVoltaTestnet";
    ChainId[ChainId["Firenzetestnetwork"] = 78110] = "Firenzetestnetwork";
    ChainId[ChainId["PolygonTestnetMumbai"] = 80001] = "PolygonTestnetMumbai";
    ChainId[ChainId["QuarkChainMainnetRoot"] = 100000] = "QuarkChainMainnetRoot";
    ChainId[ChainId["QuarkChainMainnetShard0"] = 100001] = "QuarkChainMainnetShard0";
    ChainId[ChainId["QuarkChainMainnetShard1"] = 100002] = "QuarkChainMainnetShard1";
    ChainId[ChainId["QuarkChainMainnetShard2"] = 100003] = "QuarkChainMainnetShard2";
    ChainId[ChainId["QuarkChainMainnetShard3"] = 100004] = "QuarkChainMainnetShard3";
    ChainId[ChainId["QuarkChainMainnetShard4"] = 100005] = "QuarkChainMainnetShard4";
    ChainId[ChainId["QuarkChainMainnetShard5"] = 100006] = "QuarkChainMainnetShard5";
    ChainId[ChainId["QuarkChainMainnetShard6"] = 100007] = "QuarkChainMainnetShard6";
    ChainId[ChainId["QuarkChainMainnetShard7"] = 100008] = "QuarkChainMainnetShard7";
    ChainId[ChainId["QuarkChainDevnetRoot"] = 110000] = "QuarkChainDevnetRoot";
    ChainId[ChainId["QuarkChainDevnetShard0"] = 110001] = "QuarkChainDevnetShard0";
    ChainId[ChainId["QuarkChainDevnetShard1"] = 110002] = "QuarkChainDevnetShard1";
    ChainId[ChainId["QuarkChainDevnetShard2"] = 110003] = "QuarkChainDevnetShard2";
    ChainId[ChainId["QuarkChainDevnetShard3"] = 110004] = "QuarkChainDevnetShard3";
    ChainId[ChainId["QuarkChainDevnetShard4"] = 110005] = "QuarkChainDevnetShard4";
    ChainId[ChainId["QuarkChainDevnetShard5"] = 110006] = "QuarkChainDevnetShard5";
    ChainId[ChainId["QuarkChainDevnetShard6"] = 110007] = "QuarkChainDevnetShard6";
    ChainId[ChainId["QuarkChainDevnetShard7"] = 110008] = "QuarkChainDevnetShard7";
    ChainId[ChainId["Akroma"] = 200625] = "Akroma";
    ChainId[ChainId["AlayaDevTestnet"] = 201030] = "AlayaDevTestnet";
    ChainId[ChainId["PlatONDevTestnet"] = 210309] = "PlatONDevTestnet";
    ChainId[ChainId["ARTISsigma1"] = 246529] = "ARTISsigma1";
    ChainId[ChainId["ARTISTestnettau1"] = 246785] = "ARTISTestnettau1";
    ChainId[ChainId["SocialSmartChainMainnet"] = 281121] = "SocialSmartChainMainnet";
    ChainId[ChainId["PolisTestnet"] = 333888] = "PolisTestnet";
    ChainId[ChainId["PolisMainnet"] = 333999] = "PolisMainnet";
    ChainId[ChainId["ArbitrumTestnetRinkeby"] = 421611] = "ArbitrumTestnetRinkeby";
    ChainId[ChainId["EluvioContentFabric"] = 955305] = "EluvioContentFabric";
    ChainId[ChainId["EthoProtocol"] = 1313114] = "EthoProtocol";
    ChainId[ChainId["Xerom"] = 1313500] = "Xerom";
    ChainId[ChainId["Musicoin"] = 7762959] = "Musicoin";
    ChainId[ChainId["PepChainChurchill"] = 13371337] = "PepChainChurchill";
    ChainId[ChainId["IOLite"] = 18289463] = "IOLite";
    ChainId[ChainId["Quarkblockchain"] = 20181205] = "Quarkblockchain";
    ChainId[ChainId["AuxiliumNetworkMainnet"] = 28945486] = "AuxiliumNetworkMainnet";
    ChainId[ChainId["JoysDigitalMainnet"] = 35855456] = "JoysDigitalMainnet";
    ChainId[ChainId["Aquachain"] = 61717561] = "Aquachain";
    ChainId[ChainId["JoysDigitalTestNet"] = 99415706] = "JoysDigitalTestNet";
    ChainId[ChainId["GatherMainnetNetwork"] = 192837465] = "GatherMainnetNetwork";
    ChainId[ChainId["NeonEVMDevNet"] = 245022926] = "NeonEVMDevNet";
    ChainId[ChainId["NeonEVMMainNet"] = 245022934] = "NeonEVMMainNet";
    ChainId[ChainId["NeonEVMTestNet"] = 245022940] = "NeonEVMTestNet";
    ChainId[ChainId["OneLedgerMainnet"] = 311752642] = "OneLedgerMainnet";
    ChainId[ChainId["GatherTesnetNetwork"] = 356256156] = "GatherTesnetNetwork";
    ChainId[ChainId["GatherDevnetNetwork"] = 486217935] = "GatherDevnetNetwork";
    ChainId[ChainId["IPOSNetwork"] = 1122334455] = "IPOSNetwork";
    ChainId[ChainId["AuroraMainNet"] = 1313161554] = "AuroraMainNet";
    ChainId[ChainId["AuroraTestNet"] = 1313161555] = "AuroraTestNet";
    ChainId[ChainId["AuroraBetaNet"] = 1313161556] = "AuroraBetaNet";
    ChainId[ChainId["HarmonyMainnetShard0"] = 1666600000] = "HarmonyMainnetShard0";
    ChainId[ChainId["HarmonyMainnetShard1"] = 1666600001] = "HarmonyMainnetShard1";
    ChainId[ChainId["HarmonyMainnetShard2"] = 1666600002] = "HarmonyMainnetShard2";
    ChainId[ChainId["HarmonyMainnetShard3"] = 1666600003] = "HarmonyMainnetShard3";
    ChainId[ChainId["HarmonyTestnetShard0"] = 1666700000] = "HarmonyTestnetShard0";
    ChainId[ChainId["HarmonyTestnetShard1"] = 1666700001] = "HarmonyTestnetShard1";
    ChainId[ChainId["HarmonyTestnetShard2"] = 1666700002] = "HarmonyTestnetShard2";
    ChainId[ChainId["HarmonyTestnetShard3"] = 1666700003] = "HarmonyTestnetShard3";
    ChainId[ChainId["Pirl"] = 3125659152] = "Pirl";
    ChainId[ChainId["OneLedgerTestnetFrankenstein"] = 4216137055] = "OneLedgerTestnetFrankenstein";
    ChainId[ChainId["PalmTestnet"] = 11297108099] = "PalmTestnet";
    ChainId[ChainId["PalmMainnet"] = 11297108109] = "PalmMainnet";
    ChainId[ChainId["NtityMainnet"] = 197710212030] = "NtityMainnet";
    ChainId[ChainId["HaradevTestnet"] = 197710212031] = "HaradevTestnet";
    ChainId[ChainId["MolereumNetwork"] = 6022140761023] = "MolereumNetwork";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
